export const NUMERIC_UNIT_OPTIONS = [
  { value: 'µm', label: 'µm' }, // micrometer
  { value: 'mm', label: 'mm' }, // millimeter
] as const;

export type NumericUnitOption = typeof NUMERIC_UNIT_OPTIONS[number]['value'];

